import {IMqttServiceOptions} from 'ngx-mqtt';

export interface MqttApp {
  server: string;
  protocol: 'wss' | 'ws';
  port: number;
  credentials: Credentials;
  defaultEndpoint?: string;
}

interface Credentials {
  username: string;
  password: string;
  clean: boolean;
  connectTimeout: number;
  clientId?: string;
}

export const mqttApp: MqttApp = {
  server: 'b-5b8fd057-e9ae-4b3d-b0d8-9be2e395ae09-1.mq.us-east-1.amazonaws.com',
  protocol: 'wss',
  port: 61619,
  defaultEndpoint: 'test/topic/front',
  credentials: {
    username: 'controltower-mq',
    password: 'MQtowerControl',
    clean: true,
    connectTimeout: 4000,
  },
};

export const mqttOptions = (mqtt?: MqttApp): IMqttServiceOptions => ({
  ...mqtt?.credentials,
  hostname: mqtt?.server,
  port: mqtt?.port,
  protocol: (mqtt?.protocol === 'wss') ? 'wss' : 'ws',
  path: '',
});
